import Api from '@/services/api'

export default {
  registerCandidate (credentials) {
    return Api().post('/auth/signup', credentials)
  },
  generateReferral (data) {
    return Api().post('/members/generateCode', data)
  },
  signInAdmin (data) {
    return Api().post('/auth/admin', data)
  },
  signInCandidate (data) {
    return Api().post('/auth/candidate', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/authService.js